import React from 'react';

export default class UploadButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.fileInputRef = this.fileInputRef.bind(this);

    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleFileInputChange = this.handleFileInputChange.bind(this);
  }

  fileInputRef(node) {
    this.fileInput = node;
  }

  handleButtonClick() {
    this.fileInput.click();
  }

  handleFileInputChange() {
    const files = Array.from(this.fileInput.files);
    this.fileInput.value = '';
    this.props.onSelectFiles(files);
  }

  render() {
    const { onlyImages, label } = this.props;

    return (
      <div className="asset-uploader modal-asset-uploader">
        <a
          className="button left js-upload-images-button action upload-images-button modal-button svg-ico-upload"
          onClick={this.handleButtonClick}
        >
          <span className="label">{label}</span>
        </a>

        <input
          accept={onlyImages ? 'image/*' : '*'}
          multiple
          onChange={this.handleFileInputChange}
          ref={this.fileInputRef}
          style={{ display: 'none' }}
          type="file"
        />
      </div>
    );
  }
}

UploadButton.defaultProps = {
  label: 'Upload New Images',
  onlyImages: false,
};

UploadButton.propTypes = {
  label: React.PropTypes.string,
  onlyImages: React.PropTypes.bool,
  onSelectFiles: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/asset-library/upload-button.jsx